import { useMemo } from "react";

import { type ValidateCheck } from "../../../hooks/useFormField";
import styles from "./CompanyForm.module.scss";
import { useCompanyFormContext } from "./contexts";

export const companyFormId = "company-form";

type ClassNameLike = string | undefined | null | false;

export function getCompanyFormClsx(...names: ClassNameLike[]) {
  if (!names.length) return getCompanyFormStyleClassName();

  return names
    .filter(Boolean)
    .map((name) => getCompanyFormStyleClassName(name))
    .join(" ");
}

export function getCompanyFormStyleClassName(...suffixes: ClassNameLike[]) {
  return styles[[companyFormId, ...suffixes].filter(Boolean).join("__")];
}

export function getCompanyFormId(...suffixes: string[]) {
  return [companyFormId, ...suffixes].filter(Boolean).join("--");
}

export function useFormFieldChecks(
  required: boolean,
  formatRegex?: RegExp
): ValidateCheck[] {
  const { fieldRequiredErrorMessage, fieldInvalidFormatErrorMessage } =
    useCompanyFormContext();

  return useMemo(() => {
    const checks: ValidateCheck[] = [];

    if (required) {
      checks.push({ test: Boolean, message: fieldRequiredErrorMessage });
    }
    if (formatRegex) {
      checks.push({
        test: formatRegex.test.bind(formatRegex),
        message: fieldInvalidFormatErrorMessage,
      });
    }

    return checks;
  }, [
    fieldInvalidFormatErrorMessage,
    fieldRequiredErrorMessage,
    required,
    formatRegex,
  ]);
}
